import BackboneElement from './BackboneElement';
import Reference from './types/Reference';
import merge from 'lodash/merge';

export default class DuplicateReview extends BackboneElement {
    static __className = 'DuplicateReview';

    __objectStructure = {
        date: String,
        practitioner: Reference,
        medication: Reference,
        drugKey: String,
    };

    constructor(constructJson, className = 'DuplicateReview') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
